<app-menu></app-menu>
<div class="fundo uk-light">
    <div class="uk-container uk-text-center">
        <h1 class="hero-standard-title" uk-scrollspy="cls: uk-animation-slide-top-small; delay: 100">Dúvidas? Estamos aqui</h1>
        <p class="uk-text-large" style="opacity: 0.9;" uk-scrollspy="cls: uk-animation-slide-bottom-small; delay: 300">
            Encontre respostas rápidas e soluções práticas na nossa central de ajuda.
        </p>
    </div>
</div>


<div class="uk-padding uk-background-muted ">
    <div class="uk-container">
    <h1 class=" uk-text-left"><span> <b>Perguntas Frequentes</b></span></h1>
</div>

    <div class="uk-container">

        <div class="uk-child-width-1-2@l uk-child-width-1-1@s uk-grid-match uk-grid uk-text-left" uk-grid>

            <div>
                <div class="uk-border-rounded card uk-card-body uk-width-1-1@m uk-margin-large-top">

                    <img src="img/faq.png">
                </div>
            </div>
            <!-- Coluna do Accordion -->
            <div >
                <ul uk-accordion>
                    <!-- Item 1 -->
                    <li>
                        <a class="uk-accordion-title" href="#">O que é a Fluxo-Digital?</a>
                        <div class="uk-accordion-content">
                            <p>A Fluxo-Digital é uma empresa especializada em infraestrutura 
                                digital, oferecendo hospedagem web, cloud computing e serviços VPN premium.</p>
                        </div>
                    </li>

                    <!-- Item 2 -->
                    <li>
                        <a class="uk-accordion-title" href="#">Como posso contratar os serviços da Fluxo-Digital?</a>
                        <div class="uk-accordion-content">
                            <p>Todos os serviços podem ser contratados directamente pelo nosso site (Fluxo-Digital.com) por 
                                meio de uma plataforma intuitiva e 100% digital</p>
                        </div>
                    </li>

                    <!-- Item 3 -->
                    <li>
                        <a class="uk-accordion-title" href="#"> Quais serviços a Fluxo-Digital oferece? </a>
                        <div class="uk-accordion-content">
                            <p>actualmente, oferecemos três pilares de serviços: 
                                <br>
                                Hospedagem Web e Registro de Domínios – Planos otimizados e suporte especializado. 
                                <br>
                                Cloud Computing – VPSs de alto desempenho e banco de dados como serviço (DBaaS). 
                                <br>
                                VPN Premium (NoAdsVPN) – Conexão segura e sem anúncios no YouTube em diversas 
                                regiões. </p>
                        </div>
                    </li>

                    <!-- Item 4 -->
                    <li>
                        <a class="uk-accordion-title" href="#">  A Fluxo-Digital oferece suporte técnico?  </a>
                        <div class="uk-accordion-content">
                            <p>Sim! Temos suporte especializado e atendimento local para clientes em Luanda, Kinshasa e 
                                Lisboa.</p>
                        </div>
                    </li>

                    <!-- Item 5 -->
                    <li>
                        <a class="uk-accordion-title" href="#">  Quais são as vantagens de escolher a Fluxo-Digital?  </a>
                        <div class="uk-accordion-content">
                            <ul>
                                <li>Infraestrutura moderna e confiável com data centers estrategicamente distribuídos.</li>
                                <li>Atendimento especializado e suporte local.</li>
                                <li>Plataforma self-service que oferece total autonomia ao cliente.</li>
                                <li>Soluções escaláveis e acessíveis, sem burocracia</li>
                            </ul> 
                        </div>
                    </li>

                    <!-- Item 6 -->
                    <li>
                        <a class="uk-accordion-title" href="#">   Como funciona o serviço de VPN NoAdsVPN?   </a>
                        <div class="uk-accordion-content">
                            <p>Nosso serviço de VPN permite que você navegue com privacidade e segurança, além de 
                                remover anúncios do YouTube em regiões como Europa, Américas e Ásia</p> 
                        </div>
                    </li>

                    <!-- Item 7 -->
                    <li>
                        <a class="uk-accordion-title" href="#">   Posso migrar meu site de outra hospedagem para a Fluxo-Digital?   </a>
                        <div class="uk-accordion-content">
                            <p>Sim! Nossa equipe pode auxiliar no processo de migração para garantir que tudo ocorra 
                                sem interrupções.</p> 
                        </div>
                    </li>

                    
                    <!-- Item 8 -->
                    <li>
                        <a class="uk-accordion-title" href="#">   A Fluxo-Digital atende apenas grandes empresas?   </a>
                        <div class="uk-accordion-content">
                            <p>Não! Nossos serviços foram criados tanto para pequenos negócios, startups, criadores de 
                                conteúdo e grandes empresas que buscam infraestrutura digital de alto desempenho</p> 
                        </div>
                    </li>

                    <!-- Item 9 -->
                    <li>
                        <a class="uk-accordion-title" href="#">  Como posso entrar em contacto com a Fluxo-Digital?  </a>
                        <div class="uk-accordion-content">
                            <p>Você pode acessar nosso site fluxo-digital.com para suporte, dúvidas e contratação de 
                                serviços</p> 
                        </div>
                    </li>

                    <!-- Item 10 -->
                    <li>
                        <a class="uk-accordion-title" href="#">   A Fluxo-Digital é uma empresa independente?  </a>
                        <div class="uk-accordion-content">
                            <p>Não, a Fluxo-Digital opera como uma unidade de negócios dentro da FLUXODIGITAL, sem 
                                personalidade jurídica própria, o que permite mais agilidade e menos burocracia para 
                                nossos clientes.</p> 
                        </div>
                    </li>
                    <!-- Adicione mais itens conforme necessário -->
                </ul>
            </div>
        </div>
    </div>
    
</div>
<app-rodape></app-rodape>

